import React from 'react';
import { HiOutlinePlus, HiOutlineCursorArrowRays, HiOutlineXMark, HiOutlineTrash } from 'react-icons/hi2';
import { Search } from 'react-bootstrap-icons';
import './FilterBar.scss';

interface FilterBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  showSelection: boolean;
  selectedCount: number;
  onCreateClick: () => void;
  onSelectionToggle: () => void;
  onDeleteSelection: () => void;
  canCreate: boolean;
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchValue,
  onSearchChange,
  showSelection,
  selectedCount,
  onCreateClick,
  onSelectionToggle,
  onDeleteSelection,
  canCreate
}) => {
  return (
    <div className="mp-toolbar workstations-toolbar flex flex-wrap items-center gap-3">
      <div className="workstations-search-wrapper">
        <Search size={14} className="search-icon" />
        <input
          type="text"
          placeholder="Buscar estaciones de trabajo..."
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="workstations-search-input"
        />
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {!showSelection && canCreate && (
          <button className="mp-btn-primary" onClick={onCreateClick}>
            <HiOutlinePlus size={15} /> Crear estación
          </button>
        )}

        <button className="mp-toolbar-btn" onClick={onSelectionToggle}>
          {showSelection ? (
            <><HiOutlineXMark size={15} /> Cancelar</>
          ) : (
            <><HiOutlineCursorArrowRays size={15} /> Seleccionar</>
          )}
        </button>

        {showSelection && selectedCount > 0 && (
          <button className="mp-btn-danger" onClick={onDeleteSelection}>
            <HiOutlineTrash size={15} /> Eliminar ({selectedCount})
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
